import { lazy } from 'react'
import { Navigate, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { RouteSuspense } from '@/components/RouteLoadingFallback'

const UserManagement = lazy(() =>
  import('@/apps/mykoob-admin/pages/UserManagement').then((m) => ({ default: m.UserManagement }))
)
const TestAssessment = lazy(() =>
  import('@/apps/mykoob-admin/pages/TestAssessment').then((m) => ({ default: m.TestAssessment }))
)
const GradeValues = lazy(() =>
  import('@/apps/mykoob-admin/pages/GradeValues').then((m) => ({ default: m.GradeValues }))
)
const Legal = lazy(() =>
  import('@/apps/mykoob-admin/pages/Legal').then((m) => ({ default: m.Legal }))
)
const ServiceAgreement = lazy(() =>
  import('@/apps/mykoob-admin/pages/legal/ServiceAgreement').then((m) => ({
    default: m.ServiceAgreement,
  }))
)
const TermsOfService = lazy(() =>
  import('@/apps/mykoob-admin/pages/legal/TermsOfService').then((m) => ({
    default: m.TermsOfService,
  }))
)
const TermsOfUse = lazy(() =>
  import('@/apps/mykoob-admin/pages/legal/TermsOfUse').then((m) => ({ default: m.TermsOfUse }))
)
const PrivacyPolicy = lazy(() =>
  import('@/apps/mykoob-admin/pages/legal/PrivacyPolicy').then((m) => ({
    default: m.PrivacyPolicy,
  }))
)
const CookiePolicy = lazy(() =>
  import('@/apps/mykoob-admin/pages/legal/CookiePolicy').then((m) => ({ default: m.CookiePolicy }))
)
const DPA = lazy(() =>
  import('@/apps/mykoob-admin/pages/legal/DPA').then((m) => ({ default: m.DPA }))
)
const FamilyPremiumTerms = lazy(() =>
  import('@/apps/mykoob-admin/pages/legal/FamilyPremiumTerms').then((m) => ({
    default: m.FamilyPremiumTerms,
  }))
)
const FamilyPremiumDataProcessing = lazy(() =>
  import('@/apps/mykoob-admin/pages/legal/FamilyPremiumDataProcessing').then((m) => ({
    default: m.FamilyPremiumDataProcessing,
  }))
)

export const mykoobAdminRouteBranch = (
  <Route path="mykoob-admin" element={<Layout />}>
    <Route index element={<Navigate to="users" replace />} />
    <Route
      path="users"
      element={
        <RouteSuspense>
          <UserManagement />
        </RouteSuspense>
      }
    />
    <Route
      path="assessment"
      element={
        <RouteSuspense>
          <TestAssessment />
        </RouteSuspense>
      }
    />
    <Route
      path="grade-values"
      element={
        <RouteSuspense>
          <GradeValues />
        </RouteSuspense>
      }
    />
    <Route
      path="legal"
      element={
        <RouteSuspense>
          <Legal />
        </RouteSuspense>
      }
    />
    <Route
      path="legal/service-agreement"
      element={
        <RouteSuspense>
          <ServiceAgreement />
        </RouteSuspense>
      }
    />
    <Route
      path="legal/terms-of-service"
      element={
        <RouteSuspense>
          <TermsOfService />
        </RouteSuspense>
      }
    />
    <Route
      path="legal/terms-of-use"
      element={
        <RouteSuspense>
          <TermsOfUse />
        </RouteSuspense>
      }
    />
    <Route
      path="legal/privacy-policy"
      element={
        <RouteSuspense>
          <PrivacyPolicy />
        </RouteSuspense>
      }
    />
    <Route
      path="legal/cookie-policy"
      element={
        <RouteSuspense>
          <CookiePolicy />
        </RouteSuspense>
      }
    />
    <Route
      path="legal/dpa"
      element={
        <RouteSuspense>
          <DPA />
        </RouteSuspense>
      }
    />
    <Route
      path="legal/family-premium-terms"
      element={
        <RouteSuspense>
          <FamilyPremiumTerms />
        </RouteSuspense>
      }
    />
    <Route
      path="legal/family-premium-data-processing"
      element={
        <RouteSuspense>
          <FamilyPremiumDataProcessing />
        </RouteSuspense>
      }
    />
  </Route>
)
